(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.hero-slideshow__slide'));
      this.dots = Array.from(container.querySelectorAll('.hero-slideshow__dot'));
      this.arrows = Array.from(container.querySelectorAll('.hero-slideshow__arrow'));
      this.progressBarInner = container.querySelector('.hero-slideshow__progress-bar-inner');
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoplay = container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5000;
      this.autoplayTimer = null;
      this.isAnimating = false;
      if (this.totalSlides <= 1) return;
      this.init();
    }

    init() {
      this.arrows.forEach(arrow => {
        arrow.addEventListener('click', () => {
          if (arrow.dataset.direction === 'prev') this.goTo(this.currentIndex - 1);
          else this.goTo(this.currentIndex + 1);
        });
      });

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.slideIndex, 10)));
      });

      let touchStartX = 0;

      this.container.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });

      this.container.addEventListener('touchend', (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.goTo(this.currentIndex + 1);
          else this.goTo(this.currentIndex - 1);
        }
      }, { passive: true });

      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
        if (e.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
      });

      this.container.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.container.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });

      if (this.autoplay) this.startAutoplay();
      this.updateProgressBar();
    }

    goTo(index) {
      if (this.isAnimating) return;

      index = ((index % this.totalSlides) + this.totalSlides) % this.totalSlides;
      if (index === this.currentIndex) return;

      this.isAnimating = true;

      const prevIndex = this.currentIndex;
      this.currentIndex = index;

      this.slides[prevIndex].classList.remove('hero-slideshow__slide--active');
      this.slides[this.currentIndex].classList.add('hero-slideshow__slide--active');

      if (this.dots[prevIndex]) {
        this.dots[prevIndex].classList.remove('hero-slideshow__dot--active');
        this.dots[prevIndex].setAttribute('aria-selected', 'false');
      }

      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('hero-slideshow__dot--active');
        this.dots[this.currentIndex].setAttribute('aria-selected', 'true');
      }

      setTimeout(() => {
        this.isAnimating = false;
      }, 550);

      this.updateProgressBar();

      if (this.autoplay) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.pauseAutoplay();
      this.autoplayTimer = setTimeout(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    updateProgressBar() {
      if (!this.progressBarInner) return;
      this.progressBarInner.classList.remove('is-animating');
      void this.progressBarInner.offsetWidth;
      if (this.autoplay) this.progressBarInner.classList.add('is-animating');
    }
  }

  document.querySelectorAll('.hero-slideshow').forEach(el => new HeroSlideshow(el));

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const el = e.target.querySelector('.hero-slideshow');
      if (el) new HeroSlideshow(el);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
